var React = require('react');

function Profile (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"yJujXI.tif"},[React.createElement("path",{"d":"M33,32.15c-4.86,7-21.48,7-28.26,2.65a5.58,5.58,0,0,1-2.58-6.28C2.85,25.17,4,22,6.8,19.76a1.48,1.48,0,0,1,1.36,0,1.24,1.24,0,0,1,.51,1.67c-.21.43-.51.82-.74,1.24-4.88,8.74-4,10.47,6,11.94a29.44,29.44,0,0,0,9.6-.4c6.83-1.25,8.05-4,4.64-10-.75-1.35-3.56-2.93-1.32-4.3,2.05-1.25,2.95,1.81,4,3.23A24.93,24.93,0,0,1,33,27.28Z","key":0}),React.createElement("path",{"d":"M19.39,1c3.72,1.8,7.05,3.93,7.73,8.52a9.79,9.79,0,0,1-6.72,11A9.7,9.7,0,0,1,8.62,15.33,9.92,9.92,0,0,1,12,2.88c.86-.62,2.25-.55,2.57-1.91ZM17.27,4.08a7.21,7.21,0,0,0-6.67,7,6.62,6.62,0,0,0,7.27,6.67,6.57,6.57,0,0,0,6.43-7A7.16,7.16,0,0,0,17.27,4.08Z","key":1})]));
}

Profile.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 32.97 38"};

module.exports = Profile;

Profile.default = Profile;
